export function fixUrlSpaces(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const originalMethod = URLSearchParams.prototype.toString; // no need to bind because it'll be calls with fn.call
    // eslint-disable-next-line func-names
    URLSearchParams.prototype.toString = function (): string {
        return originalMethod.call(this).replace(/\+/g, '%20');
    };
}
